<template>
  <div>
    <Head title="របាយការណ៍យឺត" />
    <h1 class="moul flex items-center mb-2 text-2xl">
      <Link class="flex items-center" href="/reports"
        ><ChartPieIcon class="mr-2 w-8 h-8" /> ចំណូលចំណាយ៖ &nbsp;
        <span v-if="form.is_all === true">បង្ហាញគ្រប់ពេលទាំងអស់</span>
        <span v-else>{{ formattedDate(this.start_date) }} - {{ formattedDate(this.end_date) }}</span>
      </Link>
    </h1>
    <div class="noprint">
      <div class="flex items-center py-4 w-1/2">
        <label class="flex items-center font-bold"><input @change="handleSearch" v-model="form.is_all" type="checkbox" />បង្ហាញគ្រប់ពេលទាំងអស់</label>
      </div>
      <div v-if="form.is_all !== true" class="flex items-center w-full">
        <text-input @change="handleSearch" v-model="form.start_date" :error="errors.start_date" type="date" class="pb-8 pr-6 w-full lg:w-1/4" label="ថ្ងៃចាប់ផ្តើម *" />
        <text-input @change="handleSearch" v-model="form.end_date" :error="errors.end_date" type="date" class="pb-8 pr-6 w-full lg:w-1/4" label="ថ្ងៃចាប់បញ្ចប់ *" />
      </div>

      <!-- <button class="flex items-center mb-2 px-4 py-2 hover:text-indigo-500 text-white hover:bg-green-300 bg-green-500 rounded-md" tabindex="-1" type="button" @click="print"><PrinterIcon class="mr-1 w-5 h-5" />បោះពុម្ភ</button> -->
    </div>
    <div class="schedule mb-4 w-full bg-white">
      <div class="flex flex-col flex-wrap items-center justify-center w-full shadow-sm md:flex-row">
        <div class="p-4 w-full bg-orange-100 border md:w-1/4 xl:w-1/5">
          <p>កម្ចីសរុប</p>
          <p class="text-orange-600 text-xl font-medium">{{ summary_loan.total_loans }}</p>
          <p class="text-xs">ចំនួនកម្ចីសរុបទាំងអស់</p>
        </div>
        <div class="p-4 w-full bg-green-100 border md:w-1/4 xl:w-1/5">
          <p>កម្ចីសកម្ម</p>
          <p class="text-green-600 text-xl font-medium">{{ summary_loan.total_active_loans }}</p>
          <p class="text-xs">ចំនួនកម្ចីសកម្មសរុប (បង់មិនទាន់ដាច់)</p>
        </div>
        <div class="p-4 w-full bg-orange-100 border md:w-1/4 xl:w-1/5">
          <p>អតិថិជនសរុប</p>
          <p class="text-orange-600 text-xl font-medium">{{ summary_loan.unique_customers }} នាក់</p>
          <p class="text-xs">ចំនួនអតិថិជនដែលបានខ្ចី (ដោយមិនស្ទួន)</p>
        </div>
        <div class="p-4 w-full bg-green-100 border md:w-1/4 xl:w-1/5">
          <p>អតិថិជនសកម្ម</p>
          <p class="text-green-600 text-xl font-medium">{{ summary_loan.unique_active_customers }} នាក់</p>
          <p class="text-xs">ចំនួនអតិថិជនសកម្មសរុប (កំពុងបន្តបង់ប្រាក់)</p>
        </div>
        <div class="p-4 w-full bg-indigo-100 border md:w-1/4 xl:w-1/5">
          <p>ប្រាក់ដើមដែលបានដាក់ឲ្យខ្ចី</p>
          <p class="text-indigo-600 text-xl font-medium">{{ formatNumber(summary_loan.total_principal) }}៛</p>
          <p class="text-xs">ទំហំប្រាក់ដើមសរុបទាំងអស់</p>
        </div>
        <div class="p-4 w-full bg-red-100 border md:w-1/4 xl:w-1/5">
          <p>ប្រាក់ដើមនៅសល់</p>
          <p class="text-red-600 text-xl font-medium">{{ formatNumber(total_balance_due) }}៛</p>
          <p class="text-xs">ទំហំប្រាក់ដើមដែលនៅសល់</p>
        </div>
        <div class="p-4 w-full bg-blue-100 border md:w-1/4 xl:w-1/5">
          <p>ប្រាក់ដើមដែលត្រូវប្រមូល</p>
          <p class="text-blue-600 text-xl font-medium">{{ formatNumber(total_principal_to_pay) }}៛</p>
          <p class="text-xs">ប្រាក់ដើមត្រូវប្រមូល(ក្នុងពេលដែលបានជ្រើស)</p>
        </div>
        <div class="p-4 w-full bg-yellow-100 border md:w-1/4 xl:w-1/5">
          <p>ប្រាក់ដែលបានប្រមូលសរុប</p>
          <p class="text-yellow-600 text-xl font-medium">{{ formatNumber(total_paid) }}៛</p>
          <p class="text-xs">ប្រាក់ដែលបានប្រមូលសរុប(ដើម+ការ+សេវា+ពិន័យ)</p>
        </div>
        <div class="p-4 w-full bg-indigo-100 border md:w-1/4 xl:w-1/5">
          <p>ប្រាក់ដើមដែលបានប្រមូលសរុប</p>
          <p class="text-indigo-600 text-xl font-medium">{{ total_paid - total_principal_to_pay < 0 ? formatNumber(total_paid) : formatNumber(total_paid - (total_paid - total_principal_to_pay)) }}៛</p>
          <p class="text-xs">ប្រាក់ដែលបានប្រមូលសរុប -ការ-សេវា-ពិន័យ</p>
        </div>
        <div class="p-4 w-full bg-gray-100 border md:w-1/4 xl:w-1/5">
          <p>ប្រាក់ដែលអតិថិជនជំពាក់</p>
          <p class="text-gray-600 text-xl font-medium">{{ total_amount_due <= 0 ? formatNumber(0) : formatNumber(-1 * total_amount_due) }}៛</p>
          <p class="text-xs">ប្រាក់សរុបដែលមិនទាន់បានប្រមូល ឬបង់</p>
        </div>
        <div class="p-4 w-full bg-red-100 border md:w-1/4 xl:w-1/5">
          <p>+ចំនេញ/-ខាត</p>
          <p class="text-red-600 text-xl font-medium">{{ formatNumber(total_paid - total_principal_to_pay) }}៛</p>
          <p class="text-xs">- មានន័យថាខាត/ + មានន័យថាចំនេញ</p>
        </div>
      </div>
    </div>

    <div class="schedule bg-white">
      <div class="flex flex-wrap p-4">
        <div class="loan pr-2">
          <h2 class="py-2 text-red-600 text-xl font-medium">កម្ចីសង្ខេប៖</h2>
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-medium">
              <td class="p-1 text-center border border-black">កាលបរិច្ឆេទ</td>
              <td class="p-1 text-center border border-black">ចំនួនកម្ចី</td>
              <td class="p-1 text-center border border-black">ចំនួនសកម្ម</td>
              <td class="p-1 text-center border border-black">ចំនួនអតិថិជន</td>
              <td class="p-1 text-center border border-black">ចំនួនអតិថិជនសកម្ម</td>
              <td class="p-1 text-center border border-black">ប្រាក់ដើមសរុប</td>
            </tr>
            <tr v-for="(loan, l) in loans" :key="l" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="p-1 border border-black">{{ formattedDate(loan.min_date, true) }} - {{ formattedDate(loan.max_date, true) }}</td>
              <td class="p-1 text-center border border-black">{{ loan.total_loans }}</td>
              <td class="p-1 text-center border border-black">{{ loan.total_active_loans }}</td>
              <td class="p-1 text-center border border-black">{{ loan.unique_customers }}</td>
              <td class="p-1 text-center border border-black">{{ loan.unique_active_customers }}</td>
              <td class="p-1 text-right border border-black">{{ formatNumber(loan.total_principal) }}</td>
            </tr>
            <tr class="text-left font-medium bg-green-100">
              <td class="p-1 text-right text-indigo-600 border border-black">សរុប</td>
              <td class="p-1 text-center text-red-600 border border-black">{{ summary_loan.total_loans }} កម្ចី</td>
              <td class="p-1 text-center text-red-600 border border-black">{{ summary_loan.total_active_loans }} កម្ចី</td>
              <td class="p-1 text-center text-red-600 border border-black">{{ summary_loan.unique_customers }} នាក់</td>
              <td class="p-1 text-center text-red-600 border border-black">{{ summary_loan.unique_active_customers }} នាក់</td>
              <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(summary_loan.total_principal) }}</td>
            </tr>
          </table>
        </div>
        <div class="schedule">
          <h2 class="py-2 text-red-600 text-xl font-medium">ប្រាក់ដើមដែលត្រូវប្រមូល៖</h2>
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-medium">
              <td class="p-1 text-center border border-black">កាលបរិច្ឆេទបង់</td>
              <td class="p-1 text-center border border-black">ចំនួនដងនៃការបង់</td>
              <td class="p-1 text-center border border-black">ប្រាក់ដើមត្រូវប្រមូល</td>
              <td class="p-1 text-center border border-black">ការប្រាក់ត្រូវប្រមូល</td>
              <td class="p-1 text-center border border-black">សេវារដ្ឋបាល</td>
              <td class="p-1 text-center border border-black">ប្រាក់ពិន័យ</td>
              <td class="p-1 text-center text-green-600 font-medium border border-black">សរុបប្រាក់ត្រូវបង់</td>

              <td class="p-1 text-center text-indigo-600 border border-black">ប្រាក់ដែលបានបង់</td>
              <td class="p-1 text-center text-red-600 border border-black">នៅសល់</td>
            </tr>
            <tr v-for="(schedule, s) in schedules" :key="s" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="p-1 border border-black">{{ formattedDate(schedule.min_date) }} - {{ formattedDate(schedule.max_date) }}</td>
              <td class="p-1 text-center border border-black">{{ schedule.number_of_pay }}</td>
              <td class="p-1 text-right border border-black">{{ formatNumber(schedule.principle_amount) }}</td>
              <td class="p-1 text-right border border-black">{{ formatNumber(schedule.interest) }}</td>
              <td class="p-1 text-right border border-black">{{ formatNumber(schedule.service_fee) }}</td>
              <td class="p-1 text-right border border-black">{{ formatNumber(schedule.paid_penalty) }}</td>
              <td class="p-1 text-right text-green-600 border border-black">{{ formatNumber(schedule.total_to_pay) }}</td>
              <td class="p-1 text-right text-indigo-600 border border-black">{{ formatNumber(schedule.paid_amount) }}</td>
              <td class="p-1 text-right text-red-600 border border-black">{{ schedule.amount_due <= 0 ? formatNumber(0) : formatNumber(-1 * schedule.amount_due) }}</td>
            </tr>

            <tr class="text-left font-medium bg-green-100">
              <td class="p-1 text-right text-indigo-600 border border-black">សរុប</td>
              <td class="p-1 text-center text-red-600 border border-black">{{ total_number_of_pay }} ដង</td>
              <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_principal_to_pay) }}</td>
              <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_interest) }}</td>
              <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_service_fee) }}</td>
              <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_penalty) }}</td>
              <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_to_pay) }}</td>
              <td class="p-1 text-right text-red-600 border border-black">{{ formatNumber(total_paid) }}</td>
              <td class="p-1 text-right text-red-600 border border-black">{{ total_amount_due <= 0 ? formatNumber(0) : formatNumber(-1 * total_amount_due) }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import { ChartPieIcon, PrinterIcon } from '@heroicons/vue/24/outline'
import { formattedDate, formatNumber } from '@/helper'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    ChartPieIcon,
    PrinterIcon,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    schedules: Object,
    loans: Object,
    summary_loan: Object,
    total_principal_to_pay: Number,
    total_balance_due: Number,
    total_interest: Number,
    total_service_fee: Number,
    total_penalty: Number,
    total_to_pay: Number,
    total_paid: Number,
    total_amount_due: Number,
    total_number_of_pay: Number,
    start_date: Date,
    end_date: Date,
    is_all: Boolean,
    errors: Object,
  },
  methods: {
    formattedDate,
    formatNumber,
    print() {
      var style = document.createElement('style')
      style.appendChild(document.createTextNode('@media print { @page { size: landscape; } html, body{margin:0!important; padding:0!important;} }'))
      document.head.appendChild(style)
      window.print()
    },
    handleSearch(e) {
      e.preventDefault()
      this.form.get('/reports/daily_records')
    },
  },
  remember: 'form',
  data() {
    return {
      schedules: this.schedules,
      loans: this.loans,
      total_balance_due: this.total_balance_due,
      summary_loan: this.summary_loan,
      total_principal_to_pay: this.total_principal_to_pay,
      total_interest: this.total_interest,
      total_service_fee: this.total_service_fee,
      total_penalty: this.total_penalty,
      total_to_pay: this.total_to_pay,
      total_paid: this.total_paid,
      total_amount_due: this.total_amount_due,
      total_number_of_pay: this.total_number_of_pay,
      start_date: this.start_date,
      end_date: this.end_date,
      is_all: this.is_all,
      form: this.$inertia.form({
        start_date: this.start_date,
        end_date: this.end_date,
        is_all: this.is_all,
      }),
    }
  },
}
</script>
